import { boxExpandFinish, clipperStart, mobWiperStart, videoInStart, wiperStart } from "./variables"

export const loaderClipperVariants = {
    initial: {
        opacity: 1
    }, animate: {
        opacity: 1
    }, exit: {
        opacity: 0,
        transition: {
            duration: 1,
            ease: [0.87, 0, 0.13, 1],
            delay: 0.5
        }
    }
}

// export const testPath = {
//     opened: {
//         d: [
//             "M-0.000153062 0.000119419L1366 0L1366 351C1366 351 1247.5 350 683.496 350C119.495 350 -0.00012207 354.5 -0.00012207 354.5L-0.000153062 0.000119419Z"
//         ]
//     }, closing: (i) => ({
//         d: [
// "M1366 700H0V349C0 349 118.499 350 682.5 350C1246.5 350 1366 345.5 1366 345.5V700Z",
//             "M1366 700H0V699C0 699 118.499 378.5 682.5 378.5C1246.5 378.5 1366 699 1366 699V700Z",
//             "M1366 700H0V699C0 699 118.499 698 682.5 698C1246.5 698 1366 699 1366 699V700Z"
//         ],
//         opacity: [1, 0],
//         transition: {
//             duration: 0.75,
//             ease: [[0.32, 0, 0.67, 0], [0.33, 1, 0.68, 1]],
//             times: [0, 0.5, 1],
//             delay: !i[1] ? wiperStart + 0.1*i[0] : mobWiperStart  + 0.1*i[0],
//             opacity: {
//                 delay: !i[1] ? wiperStart + 0.55 + 0.1*i[0] : mobWiperStart + 0.55 + 0.1*i[0],
//                 duration: 0.5,
//                 times: [0, 1]
//             }
//         },
//         transitionEnd: {
//             opacity: 0
//         }
//     })
// }

// export const testPath2 = {
//     opened: {
//         d: [
//             "M-0.000153062 0.000119419L1366 0L1366 351C1366 351 1247.5 350 683.496 350C119.495 350 -0.00012207 354.5 -0.00012207 354.5L-0.000153062 0.000119419Z"
//         ]
//     }, closing: (i) => ({
//         d: [
//             "M-0.000153062 0.000119419L1366 0L1366 351C1366 351 1247.5 350 683.496 350C119.495 350 -0.00012207 354.5 -0.00012207 354.5L-0.000153062 0.000119419Z",
//             "M-0.000150177 0.000119419L1366 0L1366 1C1366 1 1247.5 321.5 683.496 321.5C119.495 321.5 -0.000150089 1.00012 -0.000150089 1.00012L-0.000150177 0.000119419Z",
//             "M-0.000122245 0.000119419L1366 0L1366 1C1366 1 1247.5 2.00001 683.496 2.00006C119.495 2.00011 -0.000122158 1.00012 -0.000122158 1.00012L-0.000122245 0.000119419Z"
//         ],
//         opacity: [1, 0],
//         transition: {
//             duration: 0.75,
//             ease: [[0.32, 0, 0.67, 0], [0.33, 1, 0.68, 1]],
//             times: [0, 0.5, 1],
//             delay: !i[1] ? wiperStart + 0.1*i[0] : mobWiperStart + 0.1*i[0],
//             opacity: {
//                 delay: !i[1] ? wiperStart + 0.55 + 0.1*i[0] : mobWiperStart + 0.55 + 0.1*i[0],
//                 duration: 0.5,
//                 times: [0, 1]
//             }
//         },
//         transitionEnd: {
//             opacity: 0
//         }
//     })
// }

export const overlayVariants = {
    closing: {
        d: [
            "M0 1080V0H1920V1079.5C1920 1079.5 1917 1079.5 1024 1081C1 1080 0 1080 0 1080Z",
            "M0 582.5V0H1920V582.5C1920 582.5 1537.8 369 982.952 369C428.108 369 0 582.5 0 582.5Z",
            "M0 -6V0H1920.5V-8C1920.5 -8 1445 -12 977 -12C509 -12 0 -6 0 -6Z",
        ],
        transition: {
            duration: 1,
            ease: [[0.32, 0, 0.67, 0], [0.33, 1, 0.68, 1]],
            times: [0, 0.5, 1],
            delay: clipperStart
        },
        transitionEnd: {
            opacity: 0
        }
    },
    // opening: {
    //     d: [
    //         "M0 -6V0H1920.5V-8C1920.5 -8 1445 -12 977 -12C509 -12 0 -6 0 -6Z",
    //         "M-1 582.351V0H1921V582.351C1921 582.351 1538.7 829 982.988 829C427.277 829 -1 582.351 -1 582.351Z", 
    //         "M0 1080V0H1920V1079.5C1920 1079.5 1917 1079.5 1024 1081C1 1080 0 1080 0 1080Z"
    //     ],
    //     transition: {
    //         duration: 1,
    //         ease: [[0.32, 0, 0.67, 0], [0.33, 1, 0.68, 1]],
    //         times: [0, 0.5, 1],
    //         delay: 0
    //     }        
    // },
    opened: {
        d: [
            "M0 1080V0H1920V1079.5C1920 1079.5 1917 1079.5 1024 1081C1 1080 0 1080 0 1080Z"
        ]
    }
}

export const overlayVariants2 = {
    closing: i => ({
        d: [
            "M0 1080V0H1920V1079.5C1920 1079.5 1917 1079.5 1024 1081C1 1080 0 1080 0 1080Z",
            "M0 582.5V0H1920V582.5C1920 582.5 1537.8 369 982.952 369C428.108 369 0 582.5 0 582.5Z",
            "M0 -6V0H1920.5V-8C1920.5 -8 1445 -12 977 -12C509 -12 0 -6 0 -6Z",
        ],
        transition: {
            duration: 1.08,
            ease: [[0.32, 0, 0.67, 0], [0.33, 1, 0.68, 1]],
            times: [0, 0.5, 1],
            delay: clipperStart,
        },
        transitionEnd: {
            opacity: 0
        }
    }),
    // opening: {
    //     d: [
    //         "M0 -6V0H1920.5V-8C1920.5 -8 1445 -12 977 -12C509 -12 0 -6 0 -6Z",
    //         "M-1 582.351V0H1921V582.351C1921 582.351 1538.7 829 982.988 829C427.277 829 -1 582.351 -1 582.351Z", 
    //         "M0 1080V0H1920V1079.5C1920 1079.5 1917 1079.5 1024 1081C1 1080 0 1080 0 1080Z"
    //     ],
    //     transition: {
    //         duration: 1.25,
    //         ease: [[0.32, 0, 0.67, 0], [0.33, 1, 0.68, 1]],
    //         times: [0, 0.5, 1],
    //         delay: 0
    //     }
    // },
    opened: {
        d: [
            "M0 1080V0H1920V1079.5C1920 1079.5 1917 1079.5 1024 1081C1 1080 0 1080 0 1080Z"
        ]
    }
}

export const testVariants = {
    opened: {
        d: "M685 404L0.5 1.5L1363 0.5L685 404Z"
    }
}

export const percentVariants = {
    initial: {
        transform: "translate3d(0, 100%, 0)"
    }, animate: (i) => ({
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: 2,
            delay: 0.25 + (0.1 * i),
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i)  => ({
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
        transition: {
            duration: 0.7, 
            delay: 1,
            ease: [0.87, 0, 0.13, 1],
        }
    })
}

export const loaderWrapperVariants = {
    initial: {
        opacity: 1, 
    }, animate: {
        opacity: 0,
        transition: {
            duration: 0.5,
            delay: videoInStart - 0.5,
            ease: "easeIn"
        } 
    }, exit: {
       

    }
}

export const posterTextVariants = {
    initial: {
        transform: "translate3d(0, 100%, 0)"
    }, animate: (i) => ({
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: 2,
            delay: 0.25 + (0.1 * i),
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i)  => ({
        transform: "translate3d(0, 100%, 0)",
        transition: {
            duration: 1, 
            delay: 0.1 * i,
            ease: [0.87, 0, 0.13, 1],
        }
    })
}

export const strikethroughVariants = {
    initial: {
        transform: "translate3d(0, -50%, 0) scale3d(0, 1, 1)"
    }, animate: {
        transform: "translate3d(0, -50%, 0) scale3d(1, 1, 1)",
        transition: {
            duration: 1.5,
            delay: 1.5,
            ease: "easeInOut"
        }
    },
    exit: {
        transform: "translate3d(0, -50%, 0) scale3d(1, 1, 1)",
        transition: {
            duration: 1.5,
            delay: 1.5,
            ease: "easeInOut"
        }
    }
}

export const posterTextCenterVariants = {
    initial: {
        transform: "translate3d(-50%, 100%, 0)"
    }, animate: (i) => ({
        transform: "translate3d(-50%, 0%, 0)",
        transition: {
            duration: 2,
            delay: 0.25 + (0.1 * i),
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i)  => ({
        transform: "translate3d(-50%, 100%, 0)",
        transition: {
            duration: 1, 
            delay: 0.1 * i,
            ease: [0.87, 0, 0.13, 1],
        }
    })
}

export const loaderTextVariants={
    initial: {
        transform: "translate(-50%, 100%)"
    }, animate: (i) => ({
        transform: [null, "translate(-50%, 0%)",  "translate(-50%, 0%)", "translate(-50%, -100%)"],
        opacity: [0, 1,  1, 0],
        transition: {
            duration: i[2] ? 1.2 : 1.35,
            delay: i[2] ? (1.2 * i[0] + (i[1] * 0.35)) : (1.35 * i[0] + (i[1] * 0.35)),
            times: [0, 0.4, 0.6, 1],
            ease: [
                [0.55, 0, 1, 0.45],
                [0.55, 0, 1, 0.45],
                [0.55, 0, 1, 0.45]
            ],
            
        }
    }), endAnimate: (i) => ({
        transform: ["translate(-50%, 0%)", "translate(-50%, 0%)",  "translate(-50%, 0%)", "translate(-50%, -100%)"],
        opacity: [0, 1,  1, 0],
        transition: {
            duration: i[2] ? 1.2 : 1.5,
            delay: i[2] ? (1.2 * i[0] + (i[1] * 0.35)) : (1.5 * i[0] + (i[1] * 0.35)),
            times: [0, 0.4, 0.6, 1],
            ease: [
                [0.16, 1, 0.3, 1],
                [0.16, 1, 0.3, 1],
                [0.7, 0, 0.84, 0]
                
            ]
        }
    }),
    exit: {
        transform: "translate(-50%, -100%)",
        transition: {
            duration: 1,
            ease: [0.7, 0, 0.84, 0]
        }
    }
}
